{
    "name": "@cyan-blue/web",
    "version": "1.0.0",
    "private": true
}
